export const base_url =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api/"
    : "https://pulseback.greenafricafarm.com/api/";
